import { useTranslation } from "react-i18next";
import { complexDigitToman, convertToJalaliWithoutTime } from "../../../../tools/tools";
import { useDealer, useReport } from "../../../../tools/api";
import ReportPage, { col, PrintButton, usePrintDocument } from "../../../auxiliary/report/ReportPage";
import CWPrint from "../../printDocument/cwPrint";
import { fromDocumentInfo } from "../../printDocument/fromDocumentInfo";

const CWReport = () => {
	const [t] = useTranslation("global");
	const { queryCoPurchaseDealerByDate } = useDealer();
	const { queryCOPurchaseDocumentInfo } = useReport();
	const { busy, print } = usePrintDocument();

	// errors (e.g. 1111 "اطلاعاتی یافت نشد") are already shown by QueryAPI
	const printDoc = (copurchaseid) =>
		print(async () => {
			if (!copurchaseid) return null;
			const response = await queryCOPurchaseDocumentInfo({ copurchaseid });
			return response && !response.HasError && response.Result ? <CWPrint print={fromDocumentInfo(response.Result)} /> : null;
		});

	const columns = [
		col("نام کاربری", "username"),
		col("شماره", "msisdn"),
		col("قیمت (تومان)", "price"),
		col("سودفروش (تومان)", "commission"),
		col("تاریخ تغییر مالکیت", "purchaseDate"),
		col("وضعیت", "status"),
		col("چاپ سند", "printdoc", {
			excel: false,
			render: (_, row) => (
				<PrintButton onClick={() => printDoc(row._raw.copurchaseId)} />
			),
		}),
	];

	return (
		<ReportPage
			title={t("changeOwnerShip.report.title")}
			prefix="cw"
			query={queryCoPurchaseDealerByDate}
			columns={columns}
			toRow={(item) => ({
				username: item.username,
				msisdn: item.msisdn,
				price: complexDigitToman(item.purchaseAmount),
				commission: complexDigitToman(item.salesCommission),
				purchaseDate: convertToJalaliWithoutTime(item.operationdate),
				status: item.purchasestate,
			})}
			excel={{ sheet: "گزارشات تغییرمالکیت سیم‌کارت", file: "ownership-transfer-report.xlsx" }}
			busy={busy}
		/>
	);
};

export default CWReport;
